import { Injectable } from '@angular/core';
import { ApiService } from '../..';

@Injectable()
export class ThongkemangtaiService {

  constructor(
    public api: ApiService
  ) { }

  APIURL_Chung = "api/ExcuteOracle"
  //Lấy báo cáo thống kê
  public baocao_thongkemangtai(danhmucid, tungay, denngay, loaitai, canpha, pagenum, numrecs, mataikhoan) {
    var param = {
      "config": '{"namesql":"PKG_BC_THONGKEMANGTAI.P_LAY_THONGKE_MANGTAI","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '","v_Tungay":"' + tungay + '","v_Denngay":"' + denngay +
        '","v_Loaitai":"' + loaitai + '","v_Canpha":"' + canpha + '","v_pagenum":"' + pagenum + '","v_numrecs":"' + numrecs + '","v_mataikhoan":"' + mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  public baocao_dulieupmax(danhmucid, tungay, denngay) {
    var param = {
      "config": '{"namesql":"PKG_BC_THONGKEMANGTAI.P_LAY_CONGSUAT_MAX","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '","v_Tungay":"' + tungay + '","v_Denngay":"' + denngay + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  exportExcel(danhmucid, tungay, denngay, loaitai, canpha, tendonvi, tenchucnang, noidungbaocao, thoigian, mataikhoan) {
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tenkhachhang", "label": "Tên trạm biến áp", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "congsuat", "label": "Công suất (KAV)", "horizontalalignment": "right" },
      { "name": "ucaoha", "label": "U cao (KV)", "horizontalalignment": "right" },
      { "name": "uha", "label": "U hạ (KV)", "horizontalalignment": "right" },
      { "name": "idinhmuc", "label": "Iđm (A)", "horizontalalignment": "right" },
      { "name": "ia", "label": "Ia (A)", "horizontalalignment": "right" },
      { "name": "ib", "label": "Ib (A)", "horizontalalignment": "right" },
      { "name": "ic", "label": "Ic (A)", "horizontalalignment": "right" },
      { "name": "io", "label": "Io (A)", "horizontalalignment": "right" },
      { "name": "imax", "label": "Imax (A)", "horizontalalignment": "right" },
      { "name": "ua", "label": "Ua (V)", "horizontalalignment": "right" },
      { "name": "ub", "label": "Ub (V)", "horizontalalignment": "right" },
      { "name": "uc", "label": "Uc (V)", "horizontalalignment": "right" },
      { "name": "Cosfi", "label": "cos phi", "horizontalalignment": "right" },
      { "name": "itb", "label": "So sánh Io", "horizontalalignment": "right" },
      { "name": "canpha", "label": "Cần cân pha", "horizontalalignment": "left" },
      { "name": "time", "label": "Thời gian", "horizontalalignment": "center" },
      { "name": "mucdomangtai", "label": "Mức độ mang tải (%)", "horizontalalignment": "right" },
      { "name": "ghichu", "label": "Ghi chú", "horizontalalignment": "left" }
    ];
    let para: any = JSON.stringify({
      v_Danhmucid: danhmucid,
      v_Tungay: tungay,
      v_Denngay: denngay,
      v_Loaitai: loaitai,
      v_Canpha: canpha,
      v_pagenum: 0,
      v_numrecs: 1000000,
      v_mataikhoan: mataikhoan
    });
    let config = JSON.stringify({ namesql: "PKG_BC_THONGKEMANGTAI.P_LAY_THONGKE_MANGTAI", connstr: "Amiss42" });
    return this.api.exportExcel("", columns, para, config, tendonvi, tenchucnang, noidungbaocao, thoigian);
  }

  saveExcel(danhmucid, tungay, denngay, loaitai, canpha, tendonvi, tenchucnang, noidungbaocao, thoigian, mataikhoan) {
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tenkhachhang", "label": "Tên trạm biến áp", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "congsuat", "label": "Công suất (KAV)", "horizontalalignment": "right" },
      { "name": "ucaoha", "label": "U cao (KV)", "horizontalalignment": "right" },
      { "name": "uha", "label": "U hạ (KV)", "horizontalalignment": "right" },
      { "name": "idinhmuc", "label": "Iđm (A)", "horizontalalignment": "right" },
      { "name": "ia", "label": "Ia (A)", "horizontalalignment": "right" },
      { "name": "ib", "label": "Ib (A)", "horizontalalignment": "right" },
      { "name": "ic", "label": "Ic (A)", "horizontalalignment": "right" },
      { "name": "io", "label": "Io (A)", "horizontalalignment": "right" },
      { "name": "imax", "label": "Imax (A)", "horizontalalignment": "right" },
      { "name": "ua", "label": "Ua (V)", "horizontalalignment": "right" },
      { "name": "ub", "label": "Ub (V)", "horizontalalignment": "right" },
      { "name": "uc", "label": "Uc (V)", "horizontalalignment": "right" },
      { "name": "Cosfi", "label": "cos phi", "horizontalalignment": "right" },
      { "name": "itb", "label": "So sánh Io", "horizontalalignment": "right" },
      { "name": "canpha", "label": "Cần cân pha", "horizontalalignment": "left" },
      { "name": "time", "label": "Thời gian", "horizontalalignment": "center" },
      { "name": "mucdomangtai", "label": "Mức độ mang tải (%)", "horizontalalignment": "right" },
      { "name": "ghichu", "label": "Ghi chú", "horizontalalignment": "left" }
    ];
    let para: any = JSON.stringify({
      v_Danhmucid: danhmucid,
      v_Tungay: tungay,
      v_Denngay: denngay,
      v_Loaitai: loaitai,
      v_Canpha: canpha,
      v_pagenum: 0,
      v_numrecs: 1000000,
      v_mataikhoan: mataikhoan
    });
    let config = JSON.stringify({ namesql: "PKG_BC_THONGKEMANGTAI.P_LAY_THONGKE_MANGTAI", connstr: "Amiss42" });

    let dateNow = new Date();
    let strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi + "_" + strDate,
      header: "",
      filename: fileName,
      sheets: tenchucnang,
      columns: columns,
      data: "",
      mataikhoan: mataikhoan,
      danhmucid: danhmucid,
      loaibaocao: 1,
      tenbaocao: "Thống kê mang tải",
    };
    return this.api.Excute("api/SaveExcel", param);
  }


}




// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/thong-ke-mang-tai/thongkemangtai.service.ts